import React, { useState } from "react";
import { CardSurface } from "./CardSurface";

const SAMPLE = {
  business: {
    namaPenuh: "Nama Penuh Anda",
    namaPerniagaan: "Nama Perniagaan",
    telefon: "012-345 6789",
  },
  businessAddress: { line1: "Alamat perniagaan", city: "Bandar", state: "Selangor" },
};

export const LivePreview = ({ styleKey, order, templateName, testIdSuffix = "" }) => {
  const [side, setSide] = useState("front");
  const data = order || SAMPLE;
  const logo = order?.logoChoice === "has_logo" ? order.logoPreview : null;

  const tab = (key) =>
    `flex-1 h-11 rounded-xl text-sm font-semibold transition-[background-color,color] duration-200 ${
      side === key
        ? "bg-gradient-to-b from-[#12876a] to-[#0f3f2f] text-white"
        : "bg-[#f1f6f3] text-[#4a5a53] hover:text-[#0f3f2f]"
    }`;

  return (
    <div data-testid={`live-preview${testIdSuffix}`}>
      <p className="t-label mb-3">
        Preview Kad {templateName ? `— ${templateName}` : ""}
      </p>

      <div className="flex gap-2 mb-4" role="tablist" aria-label="Sisi kad">
        <button
          type="button"
          role="tab"
          aria-selected={side === "front"}
          className={tab("front")}
          onClick={() => setSide("front")}
          data-testid={`preview-tab-depan${testIdSuffix}`}
        >
          DEPAN
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={side === "back"}
          className={tab("back")}
          onClick={() => setSide("back")}
          data-testid={`preview-tab-belakang${testIdSuffix}`}
        >
          BELAKANG
        </button>
      </div>

      <CardSurface
        styleKey={styleKey}
        side={side}
        data={data}
        logo={logo}
        testId={`live-preview-card${testIdSuffix}`}
        className="mx-auto"
      />

      <p className="mt-4 t-help leading-relaxed">
        Preview ini adalah paparan skrin sahaja untuk rujukan susunan maklumat. Fail cetakan
        sebenar (86mm × 52mm, depan &amp; belakang) akan disediakan secara berasingan.
      </p>
    </div>
  );
};
